import React, { Component } from 'react';
import moment from 'moment';
import IncreaseIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import IconAttach from '../../../assets/image/attach.png';
import IconDeleteFile from '../../../assets/image/delete_file.png';
import Iconfile from '../../../assets/image/file.png';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import { postCreateRequest, searchResiduesByDocumentNumber } from '../../../actions/refundRequestsActions';
import { isArray } from "../../../helpers/functions";
import SnackBar from "../../HelperComponents/SnackBar/SnackBar";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import TooltipMessage from "../../HelperComponents/TooltipMessage/TooltipMessage";
import { connect } from "react-redux";
import './CreateRefundRequest.scss';

const initialActiveItem = { amount: 1, price: 0, id: 0, lot: 0, name: '-', producer: '-', article_number: '-' };

class CreateRefundByOrderNumber extends Component {
    state = {
        activeItem: initialActiveItem,
        requestAmount: 1,
        requestSum: 0,
        files: [],
        loadingBtn: false,
        snackBarAttr: { isVisible: false, message: '', type: '' },
        comment: '',
        disabledBtn: true,
        documentNumberValue: '',
        documentResults: { data: [], query: '' },
        initDocumentSearch: false,
        selectedDocument: null,
        cartOrders: [],
        articleNumberValue: '',
    };

    debounceTimeout = null;

    handleDocumentNumberChange = (e) => {
        const value = e.target.value;
        this.setState({ documentNumberValue: value });
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
            this.handleDocumentNumberSearch();
        }, 400);
    };

    handleDocumentNumberSearch = () => {
        const { documentNumberValue } = this.state;
        if (documentNumberValue.length >= 2) {
            this.props.dispatch(searchResiduesByDocumentNumber(documentNumberValue)).then((res) => {
                const data = (res && res.payload && res.payload.data) ? res.payload.data : [];
                this.setState({ initDocumentSearch: true, documentResults: { data, query: documentNumberValue } });
            });
        } else if (documentNumberValue.length < 2) {
            this.setState({ initDocumentSearch: false });
        }
    };

    handleSelectDocument = (item) => {
        this.setState({
            activeItem: initialActiveItem,
            documentNumberValue: item.document_number,
            documentResults: { data: [], query: '' },
            initDocumentSearch: false,
            selectedDocument: item,
            cartOrders: [],
        });
    };

    handleAddToCart = (order) => {
        this.setState((prevState) => {
            if (prevState.cartOrders.find(o => o.id === order.id)) return null;
            return { cartOrders: [...prevState.cartOrders, { ...order, selectedAmount: 1 }] };
        });
    };

    handleRemoveFromCart = (orderId) => {
        this.setState((prevState) => ({
            cartOrders: prevState.cartOrders.filter(order => order.id !== orderId)
        }));
    };

    handleCartAmountChange = (orderId, delta) => {
        this.setState((prevState) => ({
            cartOrders: prevState.cartOrders.map(order => {
                if (order.id !== orderId) return order;
                const max = order.amount;
                let next = order.selectedAmount + delta;
                if (next < 1) next = 1;
                if (next > max) next = max;
                return { ...order, selectedAmount: next };
            })
        }));
    };

    onChangeComment = (e) => {
        const value = e.target.value;
        this.setState({ comment: value });
    };

    componentDidUpdate(prevProps, prevState) {
        const { comment, cartOrders } = this.state;
        const hasComment = comment && comment.trim().length > 0;
        const hasSelectedOrders = cartOrders && cartOrders.length > 0;
        const shouldBeDisabled = !hasComment || !hasSelectedOrders;
        
        if (prevState.disabledBtn !== shouldBeDisabled) {
            this.setState({ disabledBtn: shouldBeDisabled });
        }
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({ files: [...this.state.files, file] });
        }
        e.target.value = '';
    };

    handleAttachClick = (e) => {
        e.preventDefault();
        window.uploadInput.click();
    };

    handleRemoveFile = (index) => {
        const files = [...this.state.files];
        files.splice(index, 1);
        this.setState({ files });
    };

    toggleSnackBar = () => {
        this.setState({ snackBarAttr: { isVisible: false, message: '', type: '' } });
    };

    submitRequest = () => {
        this.setState({ loadingBtn: true });
        const { files, comment, selectedDocument, cartOrders } = this.state;
        const { dispatch, toggleDialog, createRefundRequest, refetch } = this.props;

        const ordersData = cartOrders.map(order => ({
            order: order.id,
            amount: order.selectedAmount,
            price: order.price * order.selectedAmount
        }));

        const formData = new FormData();

        files.forEach(file => formData.append('files', file, file.name));
        formData.append('comment', comment);
        formData.append('ordernum', null);
        formData.append('document_number', selectedDocument ? selectedDocument.id : '');
        formData.append('orders', JSON.stringify(ordersData));


        dispatch(postCreateRequest(formData)).then(res => {
            if (res && res.payload && res.payload.status === 201) {
                this.setState({
                    snackBarAttr: { isVisible: true, message: 'Заявка успешно создана', type: 'success' },
                    loadingBtn: false,
                });
                toggleDialog();
                createRefundRequest(true);
                refetch();
            } else {
                this.setState({
                    snackBarAttr: {
                        isVisible: true,
                        message: (res && res.error && res.error.response && res.error.response.data && res.error.response.data.error && res.error.response.data.error[0]) || 'Произошла ошибка. Повторите попытку позже.',
                        type: 'error',
                    },
                    loadingBtn: false,
                });
                createRefundRequest(false);
            }
        });
    };

    handleArticleNumberChange = (e) => {
        const value = e.target.value;
        this.setState({ articleNumberValue: value });
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
            this.handleArticleNumberSearch();
        }, 400);
    };

    handleArticleNumberSearch = () => {
        const { documentNumberValue, articleNumberValue } = this.state;
        if (documentNumberValue && articleNumberValue.length > 0) {
            this.props.dispatch(searchResiduesByDocumentNumber(documentNumberValue, articleNumberValue)).then((res) => {
                const data = (res && res.payload && res.payload.data) ? res.payload.data : [];
                this.setState({ documentResults: { data, query: documentNumberValue }, selectedDocument: data.find(d => d.document_number === documentNumberValue) || null });
            });
        } else if (documentNumberValue && articleNumberValue.length === 0) {
            this.props.dispatch(searchResiduesByDocumentNumber(documentNumberValue)).then((res) => {
                const data = (res && res.payload && res.payload.data) ? res.payload.data : [];
                this.setState({ documentResults: { data, query: documentNumberValue }, selectedDocument: data.find(d => d.document_number === documentNumberValue) || null });
            });
        }
    };

    render() {
        const { documentNumberValue, documentResults, initDocumentSearch, files, loadingBtn, comment, snackBarAttr, disabledBtn, selectedDocument, cartOrders, articleNumberValue } = this.state;
        return (
            <>
                <div className="dialog-form-wrapper">
                    <div className="requests_add">
                        <div className="requests_add_search">
                            <div className="requests_add_search_header">
                                <span>Номер документа</span>
                                <TooltipMessage
                                    text="Номер документа состоит из символов кириллицы"
                                    delay={500}
                                    position="top"
                                    classes='tooltip_message_refund'
                                >
                                    <InfoIcon className="info_icon" />
                                </TooltipMessage>
                            </div>
                            <input
                                type="text"
                                className='requests_add_search-input'
                                placeholder="Введите номер документа"
                                value={documentNumberValue}
                                onChange={this.handleDocumentNumberChange}
                                autoComplete="off"
                            />
                            {initDocumentSearch &&
                                <div className="search_products_list">
                                    {isArray(documentResults.data) ? documentResults.data.map((item) => (
                                        <div className="search_product_item" key={item.id} onClick={() => this.handleSelectDocument(item)}>
                                            <div className="search_product_item_head">
                                                <span>{item.document_number}</span>
                                            </div>
                                            <div className="search_product_item_info">
                                                <span className="block_label">Дата выдачи</span>
                                                <p className="block_value">
                                                    {moment(item.date).format("DD.MM.YYYY HH:mm")}
                                                </p>
                                                {/*Ignore last child style*/}
                                                <div></div>
                                            </div>
                                        </div>
                                    )) : <li>Нет совпадений</li>}
                                </div>
                            }
                        </div>
                        {selectedDocument && (
                            <div className="requests_add_search">
                                <span>Артикул</span>
                                <input
                                    type="text"
                                    className='requests_add_search-input'
                                    placeholder="Введите артикул"
                                    value={articleNumberValue}
                                    onChange={this.handleArticleNumberChange}
                                    autoComplete="off"
                                />
                            </div>
                        )}
                        {selectedDocument && Array.isArray(selectedDocument.orders) && (
                            <div className="orders_scroll_list">
                                {selectedDocument.orders.length === 0 ? (
                                    <div className="orders_scroll_list_empty">Ничего не найдено</div>
                                ) : (
                                    selectedDocument.orders.map(order => {
                                        const isInCart = cartOrders.some(o => o.id === order.id);
                                        return (
                                            <div className="order_item order_item_overlayable" key={order.id}>
                                                <div className="order_item_content">
                                                    <div className="order_item_row">
                                                        <span className="block_label">Товар</span>
                                                        <span className="block_value">{order.name}</span>
                                                    </div>
                                                    <div className="order_item_row">
                                                        <span className="block_label">Артикул</span>
                                                        <span className="block_value">{order.article_number}</span>
                                                    </div>
                                                    <div className="order_item_row">
                                                        <span className="block_label">Производитель</span>
                                                        <span className="block_value">{order.producer}</span>
                                                    </div>
                                                    <div className="order_item_row">
                                                        <span className="block_label">Количество</span>
                                                        <span className="block_value">{order.amount}</span>
                                                    </div>
                                                    <div className="order_item_row">
                                                        <span className="block_label">Цена</span>
                                                        <span className="block_value">{order.price} ₽</span>
                                                    </div>
                                                </div>
                                                {isInCart ? (
                                                    <div className="order_item_overlay order_item_overlay_selected" onClick={() => this.handleRemoveFromCart(order.id)}>
                                                        <CheckCircleIcon className="order_item_overlay_icon_selected" />
                                                        <CloseIcon className="order_item_overlay_icon_remove" />
                                                    </div>
                                                ) : (
                                                    <div className="order_item_overlay" onClick={() => this.handleAddToCart(order)}>
                                                        <AddCircleOutlineIcon className="order_item_overlay_icon" />
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        )}
                        {cartOrders.length > 0 && (
                            <div className="cart_orders_list">
                                <div className="cart_orders_title">Выбрано</div>
                                {cartOrders.map(order => (
                                    <div className="order_item" key={order.id}>
                                        <div className="order_item_row">
                                            <span className="block_label">Товар</span>
                                            <span className="block_value">{order.name}</span>
                                            <button className="cart_remove_btn" onClick={() => this.handleRemoveFromCart(order.id)}><CloseIcon /></button>
                                        </div>
                                        <div className="order_item_row">
                                            <span className="block_label">Артикул</span>
                                            <span className="block_value">{order.article_number}</span>
                                        </div>
                                        <div className="order_item_row">
                                            <span className="block_label">Производитель</span>
                                            <span className="block_value">{order.producer}</span>
                                        </div>
                                        <div className="order_item_row">
                                            <span className="block_label">Количество</span>
                                            <div className="cart_stepper">
                                                <button className="cart_stepper_btn" onClick={() => this.handleCartAmountChange(order.id, -1)} disabled={order.selectedAmount <= 1}><RemoveIcon /></button>
                                                <span className="cart_stepper_value">{order.selectedAmount}</span>
                                                <button className="cart_stepper_btn" onClick={() => this.handleCartAmountChange(order.id, 1)} disabled={order.selectedAmount >= order.amount}><IncreaseIcon /></button>
                                                <span className="cart_stepper_max">/ {order.amount}</span>
                                            </div>
                                        </div>
                                        <div className="order_item_row">
                                            <span className="block_label">Цена</span>
                                            <span className="block_value">{order.price} ₽</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="block_textarea_amount">
                            <span>Комментарий</span>
                            <textarea placeholder="Ваш комментарий" onChange={this.onChangeComment} value={comment}></textarea>
                        </div>
                        <div className="attach_file_block">
                            <input type="file" hidden ref={ref => window.uploadInput = ref} onChange={this.handleFileChange} />
                            <button className="attach_btn" onClick={this.handleAttachClick}>
                                <img src={IconAttach} alt="attach" /> Прикрепить файл
                            </button>
                            {files.map((file, i) => (
                                <div className="document_info" key={i}>
                                    <img className="doc_icon" src={Iconfile} alt="file" />
                                    <span>{file.name}</span>
                                    <button className="btn_delete_doc" onClick={() => this.handleRemoveFile(i)}>
                                        <img src={IconDeleteFile} alt="delete" />
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="btn-wrapper order-dialog-btn">
                            <DefaultButton variant="outlined" classes="cancel_btn" onClick={this.props.toggleDialog}>Отмена</DefaultButton>
                            <DefaultButton loading={loadingBtn} disabled={loadingBtn || disabledBtn} onClick={this.submitRequest}>Создать заявку</DefaultButton>
                        </div>
                    </div>
                </div>
                <SnackBar
                    open={snackBarAttr.isVisible}
                    classes={snackBarAttr.type}
                    vertical="top"
                    onClose={this.toggleSnackBar}
                >
                    {snackBarAttr.message}
                </SnackBar>
            </>
        );
    }
}

export default connect()(CreateRefundByOrderNumber);
